import React from 'react';
import { Route } from 'react-router';
import { Switch, Redirect } from 'react-router-dom';

import {
   SettingsPage,
   BuildsPage,
   NotFoundPage,
   ErrorPage,
   NoHttpErrorPage,
   NoLocalErrorPage
} from '../pages';

export const RoutePaths = {
   Settings: "/settings",
   Builds: "/builds",
   Migrate: "/migrate",
   Error: "/error",
   ErrorNoLocal: "/error/nolocal",
   ErrorNoHttp: "/error/nohttp",
}

export const navigateTo = (path) => {
   window.location = `/wp-admin/admin.php?page=my-fastapp#${path}`;
}

const checkValidSiteDomain = () => {
   return true;
   const url = window.location.href;
   if (url.includes("http://")) {
      // Only https is supported
      navigateTo(RoutePaths.ErrorNoHttp);
      return false;
   } else if (url.includes("localhost")
      || url.includes("127.0.0.1")) {
      // Only online sites are supported
      navigateTo(RoutePaths.ErrorNoLocal);
      return false;
   } else {
      return true;
   }
}

const CheckedRoute = ({ ...props }) => {
   if (checkValidSiteDomain()) {
      return <Route {...props} />;
   } else return null;
}

export const Routes = ({ ...props }) => {

   return (
      <Switch>

         <CheckedRoute exact path={RoutePaths.Settings} component={SettingsPage} />
         <CheckedRoute exact path={RoutePaths.Builds} component={BuildsPage} />

         <Route exact path={RoutePaths.ErrorNoHttp} component={NoHttpErrorPage} />
         <Route exact path={RoutePaths.ErrorNoLocal} component={NoLocalErrorPage} />
         <Route exact path={RoutePaths.Error} component={ErrorPage} />

         <Route component={NotFoundPage} />

      </Switch>
   );
}